<template>
    <div class="displayCheck">
        <el-row>
            <el-col>
                <el-button type="success" size="small" v-if="onoffManager"
                           @click.stop="newInventoryClick" style="float: left;background-color: #4ec880;color: white;border: 1px solid #4ec880;margin-bottom: 4px;font-size:13px">
                    <i :class="['iconfont', 'el-icon-plus']" style="color: #ffffff"></i>
                    添加
                </el-button>
            </el-col>
            <el-col>
                <el-table
                        :header-cell-style="{'color':'black','font-size':'15px'}"
                        :data="tableData"
                        border
                        style="width: 100%;margin-top: 10px"
                        stripe>
                    <el-table-column
                            align="center"
                            type="index"
                            label="序号"
                            width="60px">
                    </el-table-column>
                    <el-table-column
                            prop="sku_name"
                            sortable
                            label="单品"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="unit_name"
                            sortable
                            label="单位"
                            width="80px"
                            >
                    </el-table-column>
                    <el-table-column
                            width="110"
                            prop="shelf_type_name"
                            sortable
                            label="货架类型">
                    </el-table-column>
                    <el-table-column
                            width="110"
                            prop="display_position_name"
                            sortable
                            label="陈列位置">
                    </el-table-column>
                    <el-table-column
                            width="90"
                            prop="display_faces"
                            sortable
                            label="陈列面">
                    </el-table-column>
                    <el-table-column
                            width="80"
                            prop="display_rows"
                            sortable
                            label="纵深">
                    </el-table-column>
                    <el-table-column
                            prop="posm_item_name"
                            sortable
                            label="促销物料">
                    </el-table-column>
                    <el-table-column
                            label-class-name="displayCheck_table_cell"
                            fixed="right" label="操作"
                            :width="onoffManager ? 160:80"
                            style="color: #3b99f7"
                    >
                        <template slot-scope="scope">
                            <div style="text-align: center;width: 100%;height: 100%">
                                <el-button
                                        style="display: inline-block"
                                        type="warning" size="small"
                                        @click="handleDetail(scope.row)">详情
                                </el-button>
                                <el-button
                                        v-if="onoffManager"
                                        style="display: inline-block"
                                        type="danger" size="small"
                                        @click="deleteHandleDetail(scope.row)">删除
                                </el-button>
                            </div>

                        </template>
                    </el-table-column>
                </el-table>
                <pagination :page="page" @changePage="changePageClick"></pagination>
            </el-col>
        </el-row>
        <!--        陈列检查-->
        <el-dialog
                :visible.sync="inventoryBool"
                width="700px"
                :show-close="false"
                @close="closeInventoryModel"
                style="vertical-align: center;: #FFF9F3">
            <div>
                <el-row style="border-bottom: 2px dotted #e7eaec;padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">陈列检查
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" v-if="onoffManager" @click.stop="inputEditInventoryInfo"
                                       >
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click="inventoryBool = false">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <div id="inventory" style="margin-top: 20px;">
                    <el-form ref="formDisplayCheck" :model="addInventory" label-width="15%" style="margin-left: 110px" hide-required-asterisk="false" :disabled="disabled">
                        <el-form-item label="单品" class="displayCheck_star" :rules="[{required:true,message:'单品不能为空'}]" prop="sku_id">
                            <el-select v-model="addInventory.sku_id" placeholder="请选择单品" value-key="sku_id"
                                       @change="choseSku" style="width:70%;margin-left: 5%" clearable filterable>
                                <el-option
                                        v-for="item in skuList"
                                        :key="item.sku_id"
                                        :label="item.sku_name"
                                        :value="item.sku_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="包装单位">
                            <el-input v-model="addInventory.unit_name" placeholder=""  disabled style="width: 70%;
                            margin-left: 5%"></el-input>
                        </el-form-item>
                        <el-form-item label="货架类型" >
                            <el-select v-model="addInventory.shelf_type" placeholder="请选择开架或闭架" value-key="sku_id"
                                        style="width:70%;margin-left: 5%" clearable>
                                <el-option
                                        v-for="item in shelfArray"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="陈列位置">
                            <el-select v-model="addInventory.display_position" placeholder="请选择陈列位置" value-key="sku_id"
                                       style="width:70%;margin-left: 5%" clearable>
                                <el-option
                                        v-for="item in displayArray"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="陈列面">
                            <el-input-number type="number" v-model="addInventory.display_faces" placeholder="请输入商品陈列面数" controls-position="right" :min="0"
                                      style="width: 70%;margin-left: 5%"></el-input-number>
                        </el-form-item>
                        <el-form-item label="纵深">
                            <el-input-number type="number"  v-model="addInventory.display_rows" placeholder="请输入商品陈列排数" controls-position="right" :min="0"
                                      style="width: 70%;margin-left: 5%"></el-input-number>
                        </el-form-item>
                        <el-form-item label="促销物料">
                            <el-select v-model="addInventory.posm_item" placeholder="请选择使用的POSM" value-key="sku_id"
                                        style="width:70%;margin-left: 5%" clearable>
                                <el-option
                                        v-for="item in posmArray"
                                        :key="item.key"
                                        :label="item.value1"
                                        :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="说明">
                            <el-input
                                    type="textarea"
                                    :autosize="{ minRows: 4}"
                                    placeholder="请输入说明"
                                    v-model="addInventory.comments"
                            style="width: 70%;margin-left: 5%">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="上传照片" v-if="onoffManager">
                            <el-upload
                                    style="margin-left: 5%"
                                    ref="displayUpload"
                                    accept=".jpg,.png,.jpeg"
                                    action="/photos/uploadphoto"
                                    list-type="picture-card"
                                    :on-preview="dialogVisibles"
                                    :on-remove="handleRemove"
                                    :on-change="handleChange"
                                    :on-success="handleImgSuccess"
                                    :before-upload="beforeImgUpload"
                                    :data="displayChecImgData"
                                    :file-list="fileList">

                                <i class="el-icon-plus"></i>
                            </el-upload>
                            <p style="width:323px;margin-left: 5%;line-height:20px">你可以上传多张JPG或PNG格式的图片文件,
                                单个文件大小不能超过20M。</p>
                        </el-form-item>
                        <el-form-item label="上传照片" v-else>
                            <ul style="margin-left: 5%">
                                <li v-for="(item,i) in fileList" style="float: left;width: 146px;position:relative;
                                height:146px;border: 1px solid #c0ccda;border-radius: 8px;margin-right: 10px;
                                margin-bottom: 10px">
                                    <img
                                         :src="item.url"
                                         style="width: 146px;display: block;object-fit: fill;
                                   height:146px;border-radius: 8px;position: absolute"/>
                                    <div class="imgDisplay"
                                         style="width: 147px;height: 146px;position: absolute;top: 0;left: 0;
                                            transition: .2s;cursor: pointer;line-height: 146px;text-align: center;
                                            border-radius: 8px">
                                       <span style="display: inline-block;width: 50px;text-align: center">
                                             <i class="el-icon-zoom-in" style="color: white;font-size: 20px;"
                                                @click="dialogVisibles(item)"></i>
                                       </span>
                                    </div>
                                </li>
                            </ul>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-dialog>
        <!--        图片放大-->
        <el-dialog :visible.sync="dialogVisibleImg" class="dialogVisibleUp">
            <img width="100%" :src="dialogSrc" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../APIService/http'
    import pagination from '../../../../components/pagination'
    import moment from 'moment'
    export default {
        name: "displayCheck",
        props:{
            data:{
                type: Object,
                default: {}
            },
            onoffManager:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return{
                isUpload:false,
                tableData:[],
                addInventory:{},
                skuList:[],
                fileList: [],
                copyFileList: [],
                displayChecImgData:{},
                inventoryBool:false,
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                onoffManager:false,
                shelfArray : [],
                displayArray : [],
                posmArray : [],
                imageIdArray:[],
                delPhoto:'',
                dialogSrc:'',
                dialogVisibleImg:false,
            }
        },
        components: {
            pagination
        },
        created () {
            // if(this.$route.params.created_by == this.$store.getters.getUser.user_id){
            //     this.disabled = false
            // }else{
            //     this.disabled = true
            // }
            this.init()
            if(!this.onoffManager){
                this.disabled = true
            }
        },
        mounted () {
            let user = this.$store.getters.getUser
            if(this.onoffManager){
                if (this.data.created_by === user.user_id) {
                    this.disabled = false
                    this.onoffManager =true
                }else {
                    this.disabled = true
                    this.onoffManager =false
                }
            }
            this.displayChecImgData = {
                reference_obj: 'CLIENT',
                reference_id: 'com.saasyun.android',
                credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                tenant_id: this.$store.getters.getUser.tenant_id,
                username:this.$store.getters.getUser.username,
                user_id:this.$store.getters.getUser.user_id,
                event_obj : 'CAMPAIGN',
                category:'PICTURE',
            }
            this.getSkuList()
            this.getParameter()
        },
        methods: {
            choseSku(item){
                for (let i =0;i<this.skuList.length;i++){
                    if (this.skuList[i].sku_id === item) {
                        this.addInventory.unit_name = this.skuList[i].unit_name
                        this.addInventory.product_id = this.skuList[i].product_id
                        break
                    }
                }
            },
            getParameter(){
              try {
                  let user = this.$store.getters.getUser
                  let data = {
                      user_id : user.user_id,
                      tenant_id : user.tenant_id
                  }
                  http.post('/wapi/StoreTour/getParameter',data).then((res)=>{
                      if (res.success === true){
                        this.shelfArray = res.data.result_shelf
                        this.displayArray = res.data.result_display
                        this.posmArray = res.data.result_posm
                      }
                  })
              }  catch (e) {

              }
            },
            dialogVisibles(file) {
                this.dialogSrc = file.url
                this.dialogVisibleImg = true
            },
            handlePictureCardPreview(file) {
                //
                // this.dialogImageUrl = file.url;
                // this.dialogVisible = true;
            },
            //图片
            handleRemove(file, fileList) {
               this.fileList = fileList
            },
            handleChange(file, fileList){
                this.fileList = fileList
            },
            // 上传图片成功
            handleImgSuccess(response, file, fileList) {
                // console.log(file)
                // this.fileList.push({
                //     name: file.name,
                //     url: file.url,
                //     response : file.response
                // });
                // this.editInventoryInfo()
            },
            // 上传图片前的验证
            beforeImgUpload(file) {


                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                const isLt20M = file.size / 1024 / 1024 < 20 * 1.2
                this.file_size = file.size

                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                if (!isLt20M) {
                    this.error('上传图片大小不能超过 20MB!')
                }
                const nameArr = file.name.split('.')
                return isPic && isLt20M
            },
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.init()
            },
            async init(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let user = this.$store.getters.getUser
                    let data={
                        tenant_id:user.tenant_id,
                        user_id:user.user_id,
                        store_id : this.data.store_id,
                        inspection_id : this.data.activity_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                    }

                    await http.post('/wapi/StoreTour/getDisplayCheckList',data).then(res=>{
                        if (res.success === true){
                            this.page.total = res.data.arrayCount
                            this.tableData =  res.data.result
                            //获取图片

                            for(let i=0;i<this.tableData.length;i++){
                                let photoList = this.tableData[i].photoList
                                for (let j = 0; j<photoList.length;j++ ){
                                    this.getImgUrl(photoList[j].photo_id,photoList[j].created_date,photoList[j])
                                }

                            }

                            loading.close()
                        } else {
                            loading.close()
                        }

                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                    return e
                }
            },
            //通过图片id获取图片
            async getImgUrl(id,date,item) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }
                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data
                    item.url = array[0].thu_url
                    // if (array.length > 0) {
                    //     this.photoItemAgenda.photoUrl = array[0].thu_url
                    //     console.log(res)
                    //     let photoObj = {
                    //         id:id,
                    //         img:array[0].thu_url,
                    //         date:date
                    //     }
                    //     this.photoArrayAgenda.push(photoObj)
                    //     //排序
                    //     this.sortKey(this.photoArrayAgenda, "date")
                    //     this.$forceUpdate()
                    // }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            sortKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key];
                    var y = b[key];
                    return x > y ? 1 : x < y ? -1 : 0;
                });
            },
            handleDetail(item){
                this.inventoryBool = true
                this.addInventory = JSON.parse(JSON.stringify(item))
                this.fileList = item.photoList
                this.copyFileList = JSON.parse(JSON.stringify(item.photoList))
            },
            deleteHandleDetail(item){
                try {
                    this.$confirm('此操作将删除该陈列检查, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {

                        let user = this.$store.getters.getUser
                        let data = item
                        data.tenant_id = user.tenant_id
                        data.user_id = user.user_id
                        data.inspection_id = this.data.activity_id
                        data.store_id = this.data.store_id

                        http.post('/wapi/StoreTour/deleteDisplayCheck',data).then(res=>{
                            if (res.success === true){
                                this.init()
                                this.$message({
                                    type:'success',
                                    message:'删除成功'
                                })
                            }
                        })


                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                }catch (e) {

                }

            },
            closeInventoryModel(){
                this.addInventory = {}
                this.fileList = []
                this.copyFileList = []
                this.$refs["formDisplayCheck"].resetFields()
            },
            inputEditInventoryInfo(){
                this.$refs["formDisplayCheck"].validate(valid=>{
                    if(!valid){
                        return false
                    }else {
                        // this.editInventoryInfo()
                        let onoff = false

                        for (let i=0;i<this.fileList.length;i++){
                            if (this.fileList[i].status && this.fileList[i].status === 'ready'){
                                onoff = true
                                break
                            }
                        }
                        if (onoff){
                            this.$message({
                                type:'error',
                                message:'请等待图片上传完成'
                            })
                            // this.$refs.displayUpload.submit();
                        } else {
                            this.editInventoryInfo()
                        }


                    }
                })
            },
            editInventoryInfo(){
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let user = this.$store.getters.getUser
                    let data = this.addInventory
                    data.tenant_id = user.tenant_id
                    data.user_id = user.user_id
                    data.inspection_id = this.data.activity_id
                    data.store_id = this.data.store_id
                    data.imageIdArray = []   //需要添加图片的数组
                    data.deleteImageIdArray = []  //需要删除图片的数组

                    let imgArrayList = []
                    let copyFileList = this.copyFileList //拿没有新增和删除之前的图片数组

                    //处理数组  找出所有添加图片的数组
                    for (let i=0;i<this.fileList.length;i++){
                        if (this.fileList[i].response){   //如果有 response 这个属性则为添加的图片
                            let obj = this.fileList[i].response.data
                            data.imageIdArray.push(obj)
                        } else {
                            imgArrayList.push(this.fileList[i])
                        }

                    }

                    //处理数组  找出所有删除图片的数组
                    for(var i = 0; i < copyFileList.length; i++){
                        var obj = copyFileList[i];
                        var num = obj.photo_id;
                        var flag = false;
                        for(var j = 0; j < imgArrayList.length; j++){
                            var aj = imgArrayList[j];
                            var n = aj.photo_id;
                            if(n === num){
                                flag = true;
                                break;
                            }
                        }
                        if(!flag){
                            data.deleteImageIdArray.push(obj);
                        }
                    }

                    http.post('/wapi/StoreTour/editDisplayCheck',data).then(res=>{
                        if (res.success === true){

                            this.init()
                            this.$message({
                                type: 'success',
                                message:'保存成功'
                            })
                            this.inventoryBool = false
                            loading.close()
                        } else {
                            loading.close()
                        }
                    })
                    loading.close()
                }catch (e) {
                    loading.close()
                }
            },
            // 获取单品
            getSkuList(){
                try{
                    let data={
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id:this.$store.getters.getUser.user_id,
                    }
                    http.post('/wapi/StoreTour/getSkuList',data).then(res=>{
                        if(res.success === true){
                            this.skuList = res.data
                        }
                    })
                }catch (e) {
                    return e
                }
            },

            newInventoryClick(){
                this.inventoryBool=true
            },
        },
        updated() {

        }
    }
</script>

<style scoped>
    #inventory >>>.el-form-item__label{
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
    .avatar-uploader >>>.el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader >>>.el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
    .el-upload__tip {
        font-size: 15px;
        color: #9B9B9B;
        margin-top:0;
    }
    .displayCheck >>>.imgDisplay{
        opacity: 0;
    }
    .displayCheck >>>.imgDisplay:hover{
        opacity: 1;
        z-index: 99;
        background: rgba(0,0,0,0.3);
        border-radius: 10px;
    }
    .displayCheck >>> .el-form-item__error{
        margin-left: 5%;
    }
    .displayCheck >>> .displayCheck_table_cell {
        color: #2b92fa !important;
    }
    .displayCheck >>> .displayCheck_star label:after{
        content: '*';
        color: #F56C6C;
        margin-left: 4px;
    }
    .displayCheck >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    .displayCheck >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    .displayCheck >>> .el-button--danger {
        color: #FFF;
        background-color: #ED3B3F;
        border-color: #ED3B3F;
    }
    .displayCheck >>> .el-button--danger:hover {
        color: #FFF;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    .displayCheck >>> .el-input__inner::placeholder{
        text-align: left;
    }
    .displayCheck >>> .el-input-number.is-controls-right .el-input__inner {
        text-align: left;
    }
    .displayCheck >>> .el-button--small {
        padding: 9px 12px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/calendar/components/components/displayCheck.vue